import React from "react";
import { BsCurrencyDollar } from "react-icons/bs";
import IncomeCard from "../Reuse/IncomeCard";

function Income({ props }) {
  return (
    <>
      <div className="row">
        <IncomeCard
          title={"Total"}
          amount={props?.totalIncome.toFixed(3)}
          id={1}
          icon={<BsCurrencyDollar size={70} />}
        />

        <IncomeCard
          title={"Daily"}
          amount={props?.dailyTotalIncome.toFixed(3)}
          id={1}
          icon={<BsCurrencyDollar size={70} />}
        />

        <IncomeCard
          title={"Weekly"}
          amount={props?.weeklyTotalIncome.toFixed(3)}
          id={1}
          icon={<BsCurrencyDollar size={70} />}
        />

        <IncomeCard
          title={"Monthly"}
          amount={props?.monthlyTotalIncome.toFixed(3)}
          id={1}
          icon={<BsCurrencyDollar size={70} />}
        />

        <IncomeCard
          title={"Yearly"}
          amount={props?.yearlyTotalIncome.toFixed(3)}
          id={1}
          icon={<BsCurrencyDollar size={70} />}
        />
      </div>
    </>
  );
}

export default Income;
